import { afterRenderEffect, Component, signal } from '@angular/core';

import { OrganizerNavbar } from '../organizer-navbar/organizer-navbar';

@Component({
  selector: 'app-organizer-hero-section',
  imports: [OrganizerNavbar],
  templateUrl: './organizer-hero-section.html',
  styleUrl: './organizer-hero-section.css',
})
export class OrganizerHeroSection {
  detectDomain = signal(false);

  constructor() {
    afterRenderEffect(() => {
      this.detectDomain.set(window.location.pathname.includes('th'));
    });
  }
}
